import { render } from "./CreateMaintenance.vue?vue&type=template&id=2caac8e4"
import script from "./CreateMaintenance.vue?vue&type=script&lang=js"
export * from "./CreateMaintenance.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abola\\Documents\\A.Personal Dev\\CHI\\assetmentainance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__